module.exports = " <div class=swiper-item> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/SwiperItem.vue
// module id = 244
// module chunks = 0